var _defs, _rect, _text, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicNumeros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "numGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FF4081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7C4DFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 1.5,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    x: 2,
    y: 2,
    rx: 12,
    fill: "url(#numGrad)",
    filter: "url(#shadow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 31,
    fontFamily: "'Poppins', 'Arial', sans-serif",
    fontWeight: 900,
    fontSize: 20,
    fill: "#FFFFFF",
    textAnchor: "middle",
    letterSpacing: 1
  }, "123")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 12,
    r: 2.5,
    fill: "#FFD700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 36,
    r: 1.5,
    fill: "#FFFFFF",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicNumeros);
export default __webpack_public_path__ + "static/media/topic_numeros.d6a4aef8054f5d58ac78587c981beaa6.svg";
export { ForwardRef as ReactComponent };